import { render, staticRenderFns } from "./dn-trade.vue?vue&type=template&id=f8c27c6a"
import script from "./dn-trade.vue?vue&type=script&lang=js"
export * from "./dn-trade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports